import { Box } from '@mui/material';
import clsx from 'clsx';

import { tokens } from '../../../../theme/generated/tokens';
import { mergeSx } from '../../../../utils';
import { classNamesFor } from '../../../../utils/classNames';
import { markerSizeToWidth } from '../constants';
import { MarkerProps } from '../types';

const factory = classNamesFor('SquareMarker');

export const squareMarkerClassNames = {
  root: factory.root(),
};

export const SquareMarker = ({
  className,
  color = tokens.primitives.colors.green[300],
  size: _size = 'm',
  sx,
}: MarkerProps) => {
  const size = markerSizeToWidth[_size];
  return (
    <Box
      className={clsx(squareMarkerClassNames.root, className)}
      sx={mergeSx(
        {
          borderRadius: tokens.theme.radius.xs,
          backgroundColor: color,
          minWidth: size,
          width: size,
          maxWidth: size,
          minHeight: size,
          height: size,
          maxHeight: size,
        },
        sx
      )}
    />
  );
};
